export const TOPICS_CONSTANTS = {
  PAGE_TITLE: 'Generate Debate Topics',
  URL_INPUT_LABEL: 'Enter article URL',
  URL_INPUT_PLACEHOLDER: 'https://example.com/article',
  TEXT_INPUT_LABEL: 'Paste article text',
  TEXT_INPUT_PLACEHOLDER: 'Paste your article text here...',
  GENERATE_FROM_URL_BUTTON_TEXT: 'Generate topics from URL',
  GENERATE_FROM_TEXT_BUTTON_TEXT: 'Generate topics from text',
  SUGGESTED_TOPICS_TITLE: 'Suggested Topics',
  CREATE_DEBATE_BUTTON_TEXT: 'Create Debate',
  ERROR_MESSAGE: 'Try creating topics from article text',
  URL_ERROR_MESSAGE: 'Try creating topics from article URL',
} as const;
